module.exports = __webpack_public_path__ + "static/img/1.3473ce2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/1/zh/1.png
// module id = qcZe
// module chunks = 0